import DanhSachThanhTraPage from './DanhSachThanhTraPage.jsx';
import DanhSachThanhTraDaPheDuyetPage from './DanhSachThanhTraDaPheDuyetPage.jsx';
import DanhSachCuocThanhTraPage from './DanhSachCuocThanhTraPage.jsx';
import DanhSachDoiTuongTrungPage from './DanhSachDoiTuongTrungPage.jsx';
import ThemMoiCuocThanhTraPage from './ThemMoiCuocThanhTraPage.jsx';
import ChiTietCuocThanhTraPage from './ChiTietCuocThanhTraPage.jsx';
import ChinhSuaCuocThanhTraPage from './ChinhSuaCuocThanhTraPage.jsx';
import ThayTheCuocThanhTraPage from './ThayTheCuocThanhTraPage.jsx';
import ChinhSuaCuocThanhTraDotXuatPage from './ChinhSuaCuocThanhTraDotXuatPage.jsx';
import ChiTietCuocThanhTraKeHoachPage from './ChiTietCuocThanhTraKeHoachPage.jsx';

export {
  DanhSachThanhTraPage,
  DanhSachThanhTraDaPheDuyetPage,
  DanhSachCuocThanhTraPage,
  DanhSachDoiTuongTrungPage,
  ThemMoiCuocThanhTraPage,
  ChiTietCuocThanhTraPage,
  ChinhSuaCuocThanhTraPage,
  ThayTheCuocThanhTraPage,
  ChinhSuaCuocThanhTraDotXuatPage,
  ChiTietCuocThanhTraKeHoachPage
}


// WEBPACK FOOTER //
// ./src/components/pages/thanh-tra/index.js